
import { Utils } from '../lib/utils.js';

export const initDeactivate = () => {
	const autoMaxTeams = Number.isFinite(Number(window.DEACTIVATE_AUTO_MAX_TEAMS))
		? Number(window.DEACTIVATE_AUTO_MAX_TEAMS) : 4;
	const autoMaxMatches = Number.isFinite(Number(window.DEACTIVATE_AUTO_MAX_MATCHES))
		? Number(window.DEACTIVATE_AUTO_MAX_MATCHES) : 9;

	var turnOn = function (id, text) {
		$("#" + id).text(text);
		$("#" + id).css("visibility", "visible");
	};

	var turnOff = function (id) {
		$("#" + id).text("&nbsp;"); // to maintain height dimension
		$("#" + id).css("visibility", "hidden");
	};

	$("#deactivate_form").submit(function () {

		$("#deactivate_form").find(".fa-spinner").show();
		$("#deactivate_button").prop("disabled", true);

		const loginEmail = Utils.strip($("#login_email").val());
		const loginPassword = Utils.strip($("#login_password").val());
		const confirmation = Utils.strip($("#deletion_confirmation").val());

		turnOff("error");

		if (loginEmail === "") {
			turnOn("error", "Please enter your email address.");
			$("#login_email").focus();
			$("#deactivate_form").find(".fa-spinner").hide();
			$("#deactivate_button").prop("disabled", false);

		} else if (loginPassword === "") {
			turnOn("error", "Please enter your password.");
			$("#login_password").focus();
			$("#deactivate_form").find(".fa-spinner").hide();
			$("#deactivate_button").prop("disabled", false);

		} else if (confirmation.toLowerCase() !== "delete") {
			turnOn("error", "Please type \"delete\" in the confirmation box.");
			$("#deletion_confirmation").focus();
			$("#deactivate_form").find(".fa-spinner").hide();
			$("#deactivate_button").prop("disabled", false);

		} else {
			doSubmit(loginEmail, loginPassword, confirmation);
		}

		return false;
	});

	function doSubmit(loginEmail, loginPassword, confirmation, override=false) {

		const data = {
			em: loginEmail,
			pw: loginPassword,
			confirmation: confirmation,
			override: override,
		};

		$.ajax({
			url: "/deactivate",
			type: "post",
			dataType: "json",
			data: data,
		})
			.then(function (rsp) {

				if ('team_count' in rsp) {

					if (
						window.confirm(
							`You will be permanently deleting:\n\n${rsp.team_count} teams\n${rsp.match_count} matches\n\n` +
							`Because this exceeds the automated deletion threshold ` +
							`(teams <= ${autoMaxTeams}, matches <= ${autoMaxMatches}), ` +
							`your request will be manually reviewed and processed within 48 business hours.\n\n` +
							`Are you sure you want to continue?`
						)
					) {
						doSubmit(loginEmail, loginPassword, confirmation, true);
					} else {
						$("#deactivate-submit").hide();
						$("#deactivate-aborted").show();
					}
				} else {
					$("#deactivate-submit").hide();
					if (rsp && rsp.automated) {
						$("#deactivate-complete-auto").show();
					} else {
						$("#deactivate-complete-manual").show();
					}
				}
			})
			.catch(function (rsp) {

				let errorCode = '';
				if (rsp.responseJSON && rsp.responseJSON.code) {
					errorCode = rsp.responseJSON.code;
				}

				switch (errorCode) {
					case 'invalid-password':
						turnOn("error", "Password or e-mail address is incorrect.");
						break;

					case 'missing-confirmation':
						turnOn("error", "Please type \"delete\" in the confirmation box.");
						break;

					default:
						turnOn("error", "There was an unknown error. Please contact support.");
				}

				$("#deactivate_form").find(".fa-spinner").hide();
				$("#deactivate_button").prop("disabled", false);
			});
	}

};
